export default function FilterButton({text, selected, onClick}) {
    const color = selected ? 'bg-playmove-green border-playmove-green text-white' : 'border-playmove-darkgray text-playmove-darkgray';
    return (
        <button
            className={`rounded-full border-2 ${color} font-bold w-fit py-[2px] px-5 hover:bg-playmove-green hover:border-playmove-green hover:text-white`}
            onClick={onClick}>{text}</button>
    )
}